// ------------------------------------------------------------
// Kategorie dozwolone do wyświetlenia w sklepie.
// ------------------------------------------------------------
// Lista jest deklarowana NA SZTYWNO (hardcode) i NIE jest w żaden
// sposób prezentowana w UI — to wyłącznie parametr zapytania.
//
// Filtr działa "przed" załadowaniem produktów: jego wynik
// (ALLOWED_CATEGORY_IDS) trafia jako parametr `category`
// bezpośrednio do zapytania do CoCart (getProducts() w
// lib/store/products.ts) — API zwraca wtedy tylko produkty
// z podanych kategorii. Nic spoza tej listy nigdy nie jest
// pobierane ani renderowane, więc nie ma czego pokazywać/ukrywać
// po stronie klienta.
//
// UWAGA: `id` to prawdziwe ID kategorii z bazy WooCommerce
// (wp_term_taxonomy). Trzeba je uzupełnić realnymi wartościami
// z panelu WP-Admin -> Produkty -> Kategorie (najedź na kategorię,
// w linku na dole zobaczysz "tag_ID=123").
// ------------------------------------------------------------

// 🔧 TU EDYTUJESZ listę ID kategorii, które mają być widoczne w sklepie.
const ALLOWED_CATEGORY_ID_LIST: number[] = [301];

// Gotowy string w formacie akceptowanym przez CoCart/WooCommerce REST API
// (comma-separated lista ID) — do bezpośredniego przekazania jako
// `category` w parametrach useProducts()/getProducts().
export const ALLOWED_CATEGORY_IDS: string = ALLOWED_CATEGORY_ID_LIST.join(',');
